import { render, staticRenderFns } from "./SwapsFilter.vue?vue&type=template&id=748df592&"
import script from "./SwapsFilter.vue?vue&type=script&lang=js&"
export * from "./SwapsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports